// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input#textField-page-number{padding:0px;text-align:center}`, "",{"version":3,"sources":["webpack://./src/components/Table/components/Pagination/Pagination.scss"],"names":[],"mappings":"AACA,4BACE,WAAA,CACA,iBAAA","sourcesContent":["/* stylelint-disable */\ninput#textField-page-number {\n  padding: 0px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
